import NextLink from 'next/link';

import * as Styled from 'components/SearchPage/components/RecommendedAdsCarousel/RecommendedAdsCarousel.styled';

import { Carousel } from 'features/carousel/Carousel';
import { Image } from 'components/ToolkitV2/CardV2/components/Image/Image';
import { Price } from 'components/ToolkitV2/CardV2/components/Price/Price';
import { Link } from 'components/Toolkit/Button/Link';

import { useRecommendedAdsCarousel } from 'components/SearchPage/components/RecommendedAdsCarousel/RecommendedAdsCarousel.hook';

import { ORIENTATION } from 'components/ToolkitV2/CardV2/Card.typed';
import type { RecommendedeAdsCarouselProps } from 'components/SearchPage/components/RecommendedAdsCarousel/RecommendedAdsCarousel.typed';

function RecommendedAdsCarousel(props: RecommendedeAdsCarouselProps) {
  const { recommendedAds } = props;

  const SCROLL_DISTANCE = 251; // Card width + padding
  const ACCESSIBILITY_LABEL = 'recommended_ads_carousel';

  const { handlePushToDataLayerOnClick } = useRecommendedAdsCarousel();

  return (
    <Carousel
      title="Featured cars you may like"
      scrollDistance={SCROLL_DISTANCE}
      accessibilityLabel={ACCESSIBILITY_LABEL}
    >
      {recommendedAds.map((ad, index) => {
        return (
          <div
            key={ad.id}
            onClick={() => handlePushToDataLayerOnClick(index + 1)}
            id={`search_results_carousel_ad_impression_${index + 1}`}
          >
            <Link ofType="SECONDARY" NextLink={NextLink} href={ad.friendlyUrl}>
              <Styled.SCard
                header={<Styled.CardTitle>{ad.header}</Styled.CardTitle>}
                image={
                  <Image
                    orientationSmall={ORIENTATION.VERTICAL}
                    imgSrcWebp={
                      (ad.photos && ad.photos[0].small2Webp) || undefined
                    }
                    alt={ad.imageAlt}
                  />
                }
                orientationSmall={ORIENTATION.VERTICAL}
                paddingSmall="S8"
                gapSmall="S8"
                footer={
                  <Price
                    currency={ad.currency}
                    price={ad.price}
                    displayLabels={false}
                  />
                }
              />
            </Link>
          </div>
        );
      })}
    </Carousel>
  );
}

export { RecommendedAdsCarousel };
